import React from 'react';
import Hightcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Highcharts3D from 'highcharts/highcharts-3d';

const Chart3DColumn = ({chartData, title}) => {
	if (chartData == undefined || chartData.length == 0) {
		return
	}

	let cat = []
	let datas = []
	Object.entries(chartData).forEach(([key, value]) => {
		cat.push(value[0]);
		datas.push(value[1]);
	});
	
	Highcharts3D(Hightcharts);
	
	const optionsBar = {
		chart: {
			type: 'column',
			options3d: {
				enabled: true,
				alpha: 10,
				beta: 25,
				depth: 70
			}
		},
		title: {
			text: title,
			style : {
				color : '#000',
				fontSize : "14px",
				fontWeight : "bold"
			  }
		},
		plotOptions: {
			column: {
				depth: 25
			}
		},
		xAxis: {
			categories: cat,
			labels: {
				skew3d: true,
				style: {
					fontSize: '16px'
				}
			}
		},
		tooltip: {
			valueSuffix: ' 개'
		},
		series: [{
			name: '업종수',
			data: datas
		}]
	};

	return (
		<>
			<HighchartsReact highcharts={Hightcharts} options={optionsBar} />
		</>
	);
};

export default Chart3DColumn;